import React from 'react'

const BrowseProjectsIcon = (props) => (
    <svg
        width="13"
        height="11"
        viewBox="0 0 13 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M12 9.39745V10.7308H0V9.39745H12ZM9.60253 0L12.6667 3.06413L9.60253 6.12825L8.65973 5.18545L10.7811 3.06413L8.65973 0.942807L9.60253 0ZM6 4.73079V6.06412H0V4.73079H6ZM6 0.0641266V1.39746H0V0.0641266H6Z"
            fill="currentColor"
        />
    </svg>
)

export default BrowseProjectsIcon

